<template>
    <div class="digital-certificate-qr" :class="'digital-certificate-qr--' + size" data-certificate-qr>
        <a class="digital-certificate-qr__code" :href="url" :aria-label="'Verify this document: ' + url" target="_blank" rel="noopener noreferrer">
            <svg :viewBox="'0 0 ' + matrix.dimension + ' ' + matrix.dimension" role="img" aria-label="Document verification QR code" shape-rendering="crispEdges">
                <rect :width="matrix.dimension" :height="matrix.dimension" fill="#FFFFFF" />
                <path :d="matrix.path" :fill="colorDark" />
            </svg>
        </a>
        <div v-if="showLabel" class="digital-certificate-qr__label">{{ label }}</div>
    </div>
</template>
<script>
import { certificateQr } from '../common/certificateQr'
export default {
    name: 'DigitalCertificateQr',
    props: {
        url: { type:String, required:true },
        colorDark: { type:String, default:'#2F509F' },
        size: { type:String, default:'md' },
        showLabel: { type:Boolean, default:true },
        label: { type:String, default:'Scan to verify' }
    },
    computed: { matrix() { return certificateQr(this.url) } }
}
</script>
<style scoped>
.digital-certificate-qr { text-align:center; color:#17366c; flex-shrink:0; }
.digital-certificate-qr__code { display:block; background:#fff; line-height:0; }
.digital-certificate-qr__code:focus-visible { outline:2px solid #2F509F; outline-offset:3px; }
.digital-certificate-qr__code svg { display:block; width:100%; height:auto; aspect-ratio:1; }
.digital-certificate-qr__label { margin-top:4px; font:600 9px/12px Arial,sans-serif; letter-spacing:.07em; text-transform:uppercase; }
.digital-certificate-qr--lg { width:84px; }
.digital-certificate-qr--md { width:64px; }
.digital-certificate-qr--sm { width:56px; }
@media print { .digital-certificate-qr__code { print-color-adjust:exact; -webkit-print-color-adjust:exact; } }
</style>
